import { render, staticRenderFns } from "./baozha.vue?vue&type=template&id=16eac19a&scoped=true&"
import script from "./baozha.vue?vue&type=script&lang=js&"
export * from "./baozha.vue?vue&type=script&lang=js&"
import style0 from "./baozha.vue?vue&type=style&index=0&id=16eac19a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eac19a",
  null
  
)

export default component.exports